import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { Plus } from "lucide-react";
import BulkUploadDialog from "@/components/BulkUploadDialog";

export default function Dealers() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", code: "", region: "", phone: "", email: "" });
  const load = async () => { const { data } = await api.get("/sales/dealers"); setItems(data); };
  useEffect(() => { load(); }, []);
  const save = async () => { try { await api.post("/sales/dealers", form); toast.success("Dealer registered"); setOpen(false); load(); } catch (e) { toast.error(e.response?.data?.detail || "Failed"); } };
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="sales-dealers">
      <div className="flex items-start justify-between">
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-black">Dealers</h1>
          <p className="text-muted-foreground">Dealer master, performance, orders, outstanding and pricing.</p>
        </div>
        <Button onClick={() => setOpen(true)} data-testid="dealer-create-btn"><Plus className="w-4 h-4 mr-1" /> Register dealer</Button>
      </div>
      <div className="flex justify-end">
        <BulkUploadDialog
          title="Bulk upload dealers"
          templateUrl="/sales/dealers/template"
          uploadUrl="/sales/dealers/bulk"
          payloadKey="dealers"
          testId="dealer-bulk"
          onSuccess={load}
        />
      </div>
      <div className="surface-card p-4 overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Code</TableHead><TableHead>Name</TableHead><TableHead>Region</TableHead><TableHead>Phone</TableHead><TableHead>Email</TableHead><TableHead>Status</TableHead><TableHead>Outstanding</TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((d) => (
              <TableRow key={d.id} data-testid={`dealer-row-${d.id}`}>
                <TableCell className="font-mono text-xs">{d.code}</TableCell>
                <TableCell className="font-semibold">{d.name}</TableCell>
                <TableCell>{d.region || "—"}</TableCell>
                <TableCell className="text-sm">{d.phone}</TableCell>
                <TableCell className="text-sm">{d.email}</TableCell>
                <TableCell><Badge>{d.status}</Badge></TableCell>
                <TableCell>₹{(d.outstanding || 0).toLocaleString()}</TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-muted-foreground py-10">No dealers yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Register dealer</DialogTitle></DialogHeader>
          <div className="grid grid-cols-2 gap-3">
            <div className="col-span-2"><Label>Name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="dealer-name" /></div>
            <div><Label>Code</Label><Input value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} /></div>
            <div><Label>Region</Label><Input value={form.region} onChange={(e) => setForm({ ...form, region: e.target.value })} /></div>
            <div><Label>Phone</Label><Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></div>
            <div><Label>Email</Label><Input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} /></div>
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button><Button onClick={save} data-testid="dealer-save">Register</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
